import React, { Component } from 'react';
import { withFirebase } from '../../Firebase';
import { withRouter } from 'react-router-dom';
import PeerLine from '../../PeerLine/PeerLine';
import TeamLine from '../../TeamLine/TeamLine';
import CreateCapsule from '../../Home/ButtonCreate';
import 'firebase/functions';
import * as firebase from 'firebase';
import { Fade, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ActivatedCard from "./ActivatedCard";
import DragScrollProvider from 'drag-scroll-provider';
import LatestPolls from '../../Home/LatestPolls';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import "./StartedPage.css";

const INITIAL_STATE = {
  managerID: '',
  myAssignments: [],
  snackbarUpDownOpen: false,
  currentCapsuleId: '',
  action: null,
  needToRemoveIfUndo: false,
  loading: true,
  teamCapsules: [],
  peersCapsules: [],
  error: null,
  currentUserInfos: null,
};

const styles_loader = theme => ({
  root: {
    position: 'absolute',
    left: '50%',
    top: window.innerWidth > 768 ? '35vh' : '65vh'
  },
  button: {
    margin: theme.spacing.unit * 2,
  },
  progress: {
    color: '#0070A2',
  },
  placeholder: {
    position: 'relative',
    left: '-50%',
    height: 40,
  },
});

class StartedPage extends Component {

  render() {
    return (
      <StartedPageComponent />)
  }
}

class StartedPageComponentBase extends Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {

    document.body.style.background = '#F8F9FB';

    this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

      if (currentUser === null) {
        return
      }

      let querySnapshotUsers = await this.props.firebase.db.collection('users').get()
      const currentUserInfos = querySnapshotUsers.docs
        .filter(user => user.id === currentUser.uid)
        .map(doc => doc.data())[0] || { manager: '' };
      const managerID = currentUserInfos.manager;
      let querySnapshotCapsulesPeers = await this.props.firebase.db.collection('capsules').where('managers', 'array-contains', managerID).get()
      let querySnapshotCapsulesTeam = await this.props.firebase.db.collection('capsules').where('managers', 'array-contains', currentUser.uid).get()

      let peersCapsules = [];
      let teamCapsules = [];

      for (const capsule of querySnapshotCapsulesPeers.docs) {
        const data = capsule.data()
        const managers = data.managers;
        const status = data.status;

        if (status === 'begin') {

          if (managers.includes(managerID)) {
            peersCapsules = peersCapsules.concat({
              id: capsule.id,
              ...capsule.data()
            });
          }
        }
      }

      for (const capsule of querySnapshotCapsulesTeam.docs) {
        const data = capsule.data()
        const managers = data.managers;
        const status = data.status;

        if (status === 'begin') {

          if (managers.includes(currentUser.uid)) {
            teamCapsules = teamCapsules.concat({
              id: capsule.id,
              ...capsule.data()
            });
          }
        }

      }

      this.setState({
        peersCapsules,
        teamCapsules,
        sortedPeersCapsules: this.sortCapsulesByDate(peersCapsules),
        sortedTeamCapsules: this.sortCapsulesByDate(teamCapsules),
        filterTeamByRelevance: false,
        filterPeersByRelevance: false,
        loading: false,
        managerID,
        currentUserInfos,

      });

    });
  }

  openSnackbar = () => {
    this.setState({ snackbarUpDownOpen: true });
  };

  closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarUpDownOpen: false, needToRemoveIfUndo: false });
  };

  upCapsule = async (capsuleID) => {
    let querySnapshotCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get()
    let managers = querySnapshotCapsule.data().managers
    const timestamp = Date.now();
    const { currentUserInfos } = this.state
    this.setState({
      currentCapsuleId: capsuleID,
      action: 'up',
      needToRemoveIfUndo: !managers.includes(this.state.managerID)
    })

    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.state.managerID)
    })
    let newHistoric = { date: timestamp, firstname: currentUserInfos.firstname, lastname: currentUserInfos.lastname, picture: currentUserInfos.image_url_profile, status: "up" }
    await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('historic').add(newHistoric)
    this.openSnackbar();

  }

  downCapsule = async (capsuleID) => {
    let querySnapshotCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get()
    let managers = querySnapshotCapsule.data().managers
    const timestamp = Date.now();
    const { currentUserInfos } = this.state
    this.setState({
      currentCapsuleId: capsuleID,
      action: 'down',
      needToRemoveIfUndo: !managers.includes(this.props.firebase.auth.currentUser.uid)
    })
    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.props.firebase.auth.currentUser.uid)
    })
    let newHistoric = { date: timestamp, firstname: currentUserInfos.firstname, lastname: currentUserInfos.lastname, picture: currentUserInfos.image_url_profile, status: "down" }
    await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('historic').add(newHistoric)
    this.openSnackbar();
  }

  undoUpDown = async () => {
    const { action, currentCapsuleId, needToRemoveIfUndo } = this.state
    if (needToRemoveIfUndo) {
      if (action === 'up') {
        await this.props.firebase.db.collection('capsules').doc(currentCapsuleId).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.state.managerID)
        })
        this.closeSnackbar();
      }
      else {
        const currentCapsuleId = this.state.currentCapsuleId;
        await this.props.firebase.db.collection('capsules').doc(currentCapsuleId).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.props.firebase.auth.currentUser.uid)
        })
        this.closeSnackbar();
      }
    }
    this.closeSnackbar();
  }

  changePeersCapsuleFilter = () => {
    const { filterPeersByRelevance, peersCapsules } = this.state
    if (filterPeersByRelevance) {
      this.setState({
        filterPeersByRelevance: false,
        sortedPeersCapsules: this.sortCapsulesByDate(peersCapsules),
      })
    }
    else {
      this.setState({
        filterPeersByRelevance: true,
        sortedPeersCapsules: this.sortCapsulesByRelevance(peersCapsules),
      })
    }
  };

  changeTeamCapsuleFilter = () => {
    const { filterTeamByRelevance, teamCapsules } = this.state
    if (filterTeamByRelevance) {
      this.setState({
        filterTeamByRelevance: false,
        sortedTeamCapsules: this.sortCapsulesByDate(teamCapsules),
      })
    }
    else {
      this.setState({
        filterTeamByRelevance: true,
        sortedTeamCapsules: this.sortCapsulesByRelevance(teamCapsules),
      })
    }
  };

  sortCapsulesByRelevance = (capsules) => {

    capsules.forEach(capsule => {
      let sortingAlgoScore = 10 // starts at 10 but can go to 20
      let nbUsersCompany = localStorage.getItem("nbUsersCompany")
      sortingAlgoScore += capsule.nbLikes / (0.05 * nbUsersCompany) //adds a point every 5% of likes
      sortingAlgoScore += capsule.nbIdeas ? capsule.nbIdeas : 0 //adds a point for every idea
      sortingAlgoScore += capsule.nbLikeIdeas ? capsule.nbLikeIdeas / (0.02 * nbUsersCompany) : 0 //adds a point for every 2% of likes of ideas

      let finalScore = sortingAlgoScore > 20 ? 20 : sortingAlgoScore < 0 ? 0 : sortingAlgoScore

      if (!capsule.sortingAlgoScore || capsule.sortingAlgoScore !== finalScore) {
        this.props.firebase.db.collection('capsules').doc(capsule.id).update({ sortingScore: finalScore })
      }

      capsule.sortingAlgoScore = sortingAlgoScore > 20 ? 20 : sortingAlgoScore < 0 ? 0 : sortingAlgoScore
    })
    capsules.sort((capsuleA, capsuleB) => capsuleB.sortingAlgoScore - capsuleA.sortingAlgoScore)
    return capsules
  }

  sortCapsulesByDate = (capsules) => {
    let sortedCapsulesByDate = JSON.parse(JSON.stringify(capsules))
    sortedCapsulesByDate.sort((capsuleA, capsuleB) => capsuleB.creationDate - capsuleA.creationDate)
    return sortedCapsulesByDate
  }

  render() {
    const { classes } = this.props
    const { loading, peersCapsules, teamCapsules, sortedPeersCapsules, sortedTeamCapsules } = this.state
    return (
      <div>
        <LatestPolls page={'begin'} />
        <PeerLine />
        <div className={classes.root}>
          <div className={classes.placeholder}>
            <Fade
              in={loading}
              unmountOnExit
            >
              <CircularProgress className={classes.progress} />
            </Fade>
          </div>
        </div>
        <Fade in={loading === false}>
          <div className="activated-card-carousel-container">
            <DragScrollProvider>
              {({ onMouseDown, ref }) => (
                <div className="activated-card-scrolling-wrapper"
                  ref={ref}
                  onMouseDown={onMouseDown}>
                  {peersCapsules.length === 0 ?
                    <div className="basic-card-carousel-empty">
                      <div className="basic-card-carousel-empty-text">Aucune capsule pour l'instant...</div>
                    </div> : sortedPeersCapsules.map((capsule, index) => <div key={index} onClick={this.onOpen} className="activated-card-container">
                      <ActivatedCard
                        capsule={capsule}
                      />
                    </div>)}
                </div>
              )}
            </DragScrollProvider>
            <div className="d-flex justify-content-center">
              <MuiThemeProvider theme={theme}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.filterPeersByRelevance}
                      onChange={() => this.changePeersCapsuleFilter()}
                      value="filterChecked"
                      color="primary"
                    />
                  }
                  label="Tri par pertinence"
                />
              </MuiThemeProvider>
            </div>
          </div>
        </Fade>


        <TeamLine />
        <Fade in={loading === false}>
          <div className="activated-card-carousel-container">
            <DragScrollProvider>
              {({ onMouseDown, ref }) => (
                <div className="activated-card-scrolling-wrapper"
                  ref={ref}
                  onMouseDown={onMouseDown}>
                  {teamCapsules.length === 0 ?
                    <div className="basic-card-carousel-empty">
                      <div className="basic-card-carousel-empty-text">Aucune capsule pour l'instant...</div>
                    </div> :
                    sortedTeamCapsules.map((capsule, index) => <div key={index} onClick={this.onOpen} className="activated-card-container">
                      <ActivatedCard
                        capsule={capsule}
                      />
                    </div>)}
                </div>
              )}
            </DragScrollProvider>
            <div className="d-flex justify-content-center">
              <MuiThemeProvider theme={theme}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.filterTeamByRelevance}
                      onChange={() => this.changeTeamCapsuleFilter()}
                      value="filterChecked"
                      color="primary"
                    />
                  }
                  label="Tri par pertinence"
                />
              </MuiThemeProvider>
            </div>
          </div>
        </Fade>
        <CreateCapsule />
      </div>
    );
  }
}

StartedPageComponentBase.propTypes = {
  classes: PropTypes.object.isRequired,
};

const theme = createMuiTheme({
  palette: {
    primary: { main: '#0070A2' },
  },
  typography: { useNextVariants: true },
});


const StartedPageComponent = withRouter(withFirebase(withStyles(styles_loader)(StartedPageComponentBase)));

export default (StartedPage);
export { StartedPageComponent };